import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { normalizeLocaleParts, splitLocale } from './localeUtils';

// Adapted from https://gitlab.sas.com/convoy/localization/-/blob/master/l10n/locale.go#L66
export const lookthruLocales = locale => {
  const enLocale = 'en';
  const locales = [enLocale];
  if (locale === undefined) {
    return locales;
  }
  const localeParts = splitLocale(locale);
  const normalizedLocale = normalizeLocaleParts(localeParts);
  const {
    lang,
    region
  } = localeParts;
  let {
    script
  } = localeParts;
  if (lang === 'zh') {
    if (script !== 'Hans' && script !== 'Hant') {
      switch (region) {
        case 'TW':
        case 'HK':
        case 'MO':
          // eslint-disable-next-line @sas/i18n/jsx-to-localize
          script = 'Hant';
          break;
        default:
          // eslint-disable-next-line @sas/i18n/jsx-to-localize
          script = 'Hans';
          if (normalizedLocale !== 'zh') {
            locales.unshift('zh');
          }
      }
    } else if (script === 'Hans') {
      if (normalizedLocale !== 'zh') {
        locales.unshift('zh');
      }
    }
  } else if (lang !== enLocale) {
    if (lang === 'nn') locales.unshift('nb');
    locales.unshift(lang); // Lang only
  }

  if (script !== '') {
    // Lang-Script
    locales.unshift(`${lang}-${script}`);
  }
  if (region !== '') {
    // Lang-Region
    locales.unshift(`${lang}-${region}`);
    if (script !== '') {
      // Lang-Script-Region
      locales.unshift(`${lang}-${script}-${region}`);
    }
  }
  if (locale.toLowerCase().indexOf('pseudo') > -1) {
    // The '-pseudo' is stripped out in splitLocale. Add it back here.
    locales.unshift(`${normalizedLocale}-pseudo`);
  }
  return locales;
};
export class FallbackChainModule {
  constructor() {
    _defineProperty(this, "type", '3rdParty');
  }
  init(instance) {
    // The original function accepts fallbackCode as an argument. Keep it here as a reference.
    instance.services.languageUtils.toResolveHierarchy = function (code, _fallbackCode) {
      return lookthruLocales(code);
    };
  }
}
//# sourceMappingURL=FallbackChainModule.js.map